import { render, staticRenderFns } from "./SSNCard.vue?vue&type=template&id=3a46f64a&scoped=true&"
import script from "./SSNCard.vue?vue&type=script&lang=ts&"
export * from "./SSNCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a46f64a",
  null
  
)

export default component.exports